const dataMap = new Map()

export const setItem = (key, obj) => {
    dataMap.set(key, obj)
}

export const getItem = (key) => {
    let getData = null
    if (dataMap.has(key)) {
        getData = dataMap.get(key)
    }

    return getData
}

export const clearAll = () => {
    dataMap.clear()
}

export const removeItem = (key) => {
    if (dataMap.has(key)) {
        dataMap.delete(key)
    }
}
